var _objectSpread = require("E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/objectSpread2.js").default;
var _objectWithoutProperties = require("E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/objectWithoutProperties.js").default;
var _excluded = ["class", "staticClass", "style", "staticStyle", "attrs"];
require("core-js/modules/es.array.concat.js");
module.exports = {
  functional: true,
  render: function render(_h, _vm) {
    var _c = _vm._c,
      _v = _vm._v,
      data = _vm.data,
      _vm$children = _vm.children,
      children = _vm$children === void 0 ? [] : _vm$children;
    var classNames = data.class,
      staticClass = data.staticClass,
      style = data.style,
      staticStyle = data.staticStyle,
      _data$attrs = data.attrs,
      attrs = _data$attrs === void 0 ? {} : _data$attrs,
      rest = _objectWithoutProperties(data, _excluded);
    return _c('svg', _objectSpread({
      class: ["icon", classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "viewBox": "0 0 1024 1024",
        "xmlns": "http://www.w3.org/2000/svg",
        "width": "200",
        "height": "200"
      }, attrs)
    }, rest), children.concat([_c('defs'), _c('path', {
      attrs: {
        "d": "M482.88 112l-17.28 90.688-20.64 4.512a309.696 309.696 0 00-99.776 41.088l-18.688 11.84-73.28-55.04-44.64 44.64 51.904 76.416-11.392 17.76a310.016 310.016 0 00-41.568 99.584l-4.8 21.6L112 477.984v63.104l90.688 17.312 4.512 20.64a309.984 309.984 0 0041.088 99.776l11.84 18.688-55.04 73.28 44.64 44.64 76.416-51.904 17.76 11.392a310.016 310.016 0 0099.584 41.568l21.6 4.8L477.984 912h63.104l17.312-90.688 20.64-4.512a309.984 309.984 0 0099.776-41.088l18.688-11.84 73.28 55.04 44.64-44.64-51.904-76.416 11.392-17.76a310.016 310.016 0 0041.568-99.584l4.8-21.6L912 546.016V482.88l-90.688-17.312-4.512-20.64a309.984 309.984 0 00-41.088-99.776l-11.84-18.688 55.04-73.28-44.64-44.64-76.416 51.904-17.76-11.392a310.144 310.144 0 00-99.584-41.568l-21.6-4.8-12.896-90.72H482.88zm-72.32 37.856L429.984 48h171.584l14.624 102.624a374.119 374.119 0 0180.128 33.568l85.792-58.304 121.344 121.344-62.272 82.88c14.08 25.408 25.152 52.352 32.96 80.416l101.888 19.424v171.584L873.408 616.16a373.92 373.92 0 01-33.568 80.128l58.304 85.792L776.8 903.424l-82.88-62.272c-25.408 14.08-52.352 25.152-80.416 32.96L594.08 976H422.496l-14.624-102.624a373.92 373.92 0 01-80.128-33.568l-85.824 58.304-121.344-121.344 62.272-82.88a373.824 373.824 0 01-32.96-80.416L48 594.048V422.464l102.624-14.624a374.801 374.801 0 0133.568-80.128l-58.304-85.792 121.344-121.344 82.88 62.272a373.856 373.856 0 0180.416-32.96z"
      }
    }), _c('path', {
      attrs: {
        "d": "M512 704a192 192 0 110-384 192 192 0 010 384zm0-64a128 128 0 100-256 128 128 0 000 256z"
      }
    })]));
  }
};